import React, { Component } from "react"
import {Link, graphql} from 'gatsby'
import { Helmet } from "react-helmet";
import { Tabs, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Layout from "../../components/layout";
import ReactGA from 'react-ga'
import "../../css/style.css";
import "../../css/animate.min.css";
import "../../css/responsive.css";
import "../../css/bootstrap.min.css";
import check from '../../images/check-icon.svg'
import InstituteTabs from "../../components/institutiontabs";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import ScrollAnimation from 'react-animate-on-scroll';
import {Animated} from "react-animated-css";
import PopupForm from "../../components/popupForm";
import cardImg from '../../images/programs/degree.svg'
import cardImg1 from '../../images/programs/start online.svg'
import cardImg2 from '../../images/programs/get your visa.svg'
import cardImg3 from '../../images/programs/completed overseas.svg'
import UniversityCardView from '../../components/UniversityCardView'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);

class Countries  extends Component {
    constructor(props){
        super(props);
        this.state ={
            time: 90000000
        }
        
        this.readmoreFucnction = this.readmoreFucnction.bind(this)
        this.readmoreFucnction2 = this.readmoreFucnction2.bind(this)
        this.readmoreFucnction3 = this.readmoreFucnction3.bind(this)     
    }
    
    componentDidMount(){
        var swiper = new Swiper('.universities-swiper',  {
            slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                slidesPerColumn: 1,
                spaceBetween: 0,
                observer: true,
                observeParents: true,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
                slidesPerColumn: 1,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
                slidesPerColumn: 2,
                spaceBetween: 10,
                observer: true,
                observeParents: true,
            }
        }
    });
    var swiper = new Swiper('.universities-swiper',  {
        slidesPerView: 3,
    slidesPerColumn: 2,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 2,
            slidesPerColumn: 1,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
        },
        // when window width is >= 640px
        768: {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
        }
    }
});
var swiper = new Swiper('.universities-swiper',  {
    slidesPerView: 3,
slidesPerColumn: 2,
spaceBetween: 10,
observer: true,
observeParents: true,
pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
breakpoints: {
    // when window width is >= 320px
    320: {
        slidesPerView: 1,
        slidesPerColumn: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
    },
    // when window width is >= 480px
    480: {
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
    },
    // when window width is >= 640px
    768: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
    }
}
});
 

var swiper = new Swiper('.blogs-swiper', {
    slidesPerView:2,
    spaceBetween: 5,
    autoplay: true,
    // direction: 'vertical',
    speed: 300,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView:1,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
            slidesPerView: 3,
            spaceBetween: 30,
        }
    }
});


}
readmoreFucnction=()=>{
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

 readmoreFucnction2=()=> {
    var dots = document.getElementById("dots2");
    var moreText = document.getElementById("more2");
    var btnText = document.getElementById("myBtn2");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

 readmoreFucnction3() {
    var dots = document.getElementById("dots3");
    var moreText = document.getElementById("more3");
    var btnText = document.getElementById("myBtn3");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
    }
    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }
  render(){

    const uniArr = this.props.data.allWordpressWpUniversities.nodes

    const cardData = [
        {
            image: cardImg, title: "Choose Your University", text: "Get admission into a business degree into the top-ranked Murdoch university in UAE."
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first half of Year 1 online in just 3.5 months (2 modules in 7 weeks)  without any delays thanks to multiple intakes (intake every 2 months)"
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go overseas by the end of the program"
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights"
        }
    ]
    
   
    return(
        
        <div clsss="countrie-page">
            <PopupForm time={this.state.time} />
            <Layout>
                <Helmet>
                    <title>
                        Study Abroad in UAE | The WorldGrad
                    </title>
                    <meta
                        name="description"
                        content="Planning to study abroad in UAE? Get to know about some of the top universities, cost of living, visa requirements, scholarships in UAE and pursue your dream of studying overseas via The WorldGrad’s affordable and quality online education programs."
                    />
                    <meta
                        name="keywords"
                        content="best countries to study abroad, study abroad scholarships, top countries to study abroad, study abroad scholarships in india, countries to study abroad, study abroad scholarships for students,"
                    />
                </Helmet>
                <section class="countrie-banner-sec" id="country-page-banner-section-uae">    <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible={true}>  
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="countrie-banner-inner" >
                                    <ol class="transparentbreadcrumb breadcrumb">
                                        <li class="breadcrumb-item"><a href="/">The WorldGrad </a></li> 
                                        <li class="breadcrumb-item active"> Countries</li>
                                    </ol>
                                    <div class="text-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s" id="country-banner-image-container">
                                        <h3>Learn More About Studying In United Arab Emirates (UAE)</h3>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>   </Animated> 
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/Dubai/dubai_11zon-min_ndripb.jpg" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>UAE: Overview</h3>
                                    {/* <p className="country-usa-overview">
                                        With some of the best business and employment opportunities available, it is no surprise that UAE attracts people <span id="dots3">...</span><span id="more3">  from all corners of the world. This ultra modern city with world class infrastructure and a strategic location in the heart of the middle-east is a hub for education and commerce. The universities of UAE have the added benefits of having a culturally diverse student body, lower costs and extremely safe environments. And another bonus for Indian students is that home is never too far away.</span><a href="javascript:void(0)" onClick={() => this.readmoreFucnction3()} id="myBtn3">Read more</a>
                                    </p> */}
                                    <p className="country-usa-overview">
                                        With some of the best business and employment opportunities available, it is no surprise that UAE attracts people from all corners of the world. This ultra modern city with world class infrastructure and a strategic location in the heart of the middle-east is a hub for education and commerce. The universities of UAE have the added benefits of having a culturally diverse student body, lower costs and extremely safe environments. And another bonus for Indian students is that home is never too far away. 
                                    </p>
                                    <ul>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Highest quality of living in the Middle East and Africa region</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Lower costs of tuition fees and living expenses compared to the US, UK and Australia</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>2nd best city in the world for expats to start a new business</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Tax free - no wealth tax, no corporate tax and no income tax</li>
                                    </ul>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6 order-first order-md-last">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/Dubai/Duabi_second_jycepk-1.jpg" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>Cost of Education In UAE</h3>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>University Tuition Fees</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Depending on the course you choose, the typical annual fees for a foreign university campus in UAE would be in the range of AED 49,200 to 74,000
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Average Student Living Costs</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Depending on your proximity to city centre and spending habits, living expenses are likely to cost anywhere between AED 2,500 and AED 4000 per month
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Scholarships and Savings with The WorldGrad</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                By completing a part of Year 1 online from home with The WorldGrad you can save up to AED 30,000: ~AED 12,500 in tuition fees and ~AED 17,500 in living cost
                                            </p>
                                        </li>
                                    </ul>

                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/Dubai/uk_ekbc8g.jpg" alt=""
                                        class="img-fluid"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>UAE Student Visa Guidance</h3>

                                    <p className="country-usa-overview-mini">
                                        You would require a confirmation letter from the overseas institution to apply for a student visa
                                    </p>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Visa Requirements</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Once you get the confirmation letter from your university you will need to show proof of sufficient funds to cover airfare, course fees and living costs. You will also be required to demonstrate English language proficiency based on the recognized standardized tests like IELTS. Lastly, a medical check-up and criminal record check may also be needed.
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Timelines</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Your student visa will take a maximum of 5 weeks to be processed and allows you to stay in UAE for up to 5 years. This is true for both UG as well as PG students.
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Post Study Work-Rights</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                You will be eligible to finish your studies and then look for work in UAE within the 5 year validity period of your visa. Upon securing a job or the end of the 5 year period you can apply for PSWR to extend your stay.
                                            </p>
                                        </li>
                                    </ul>

                                </ScrollAnimation>
                                <a
                                    class="btn-default visa-visit-btn mx-auto"
                                    href="https://u.ae/en/information-and-services/education/higher-education/student-visa"
                                    target="_blank"
                                    onClick={() => {
                                        this.handlePopupWindow()
                                        ReactGA.event({
                                            category: "Countries",
                                            action: "Clicks",
                                            label: "Visit Visa Website - Our Visa Guidance for Australia"
                                        })
                                    }}
                                >
                                    VIsit VISA website
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container justify-content-center align-items-center">
                            <div className="col-md-6 order-first order-md-last">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/giorgio-trovato-WyxqQpyFNk8-unsplash-min-_1_.webp" alt=""
                                        class="img-fluid countries-page-images"
                                        style={{ borderRadius: "15px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>Employability & Careers In UAE</h3>

                                    <ul>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Industries</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                UAE economy is the 5th largest economy amongst the middle east countries with a GDP of USD 421 billion in 2020. The UAE economy is highly reliant on its revenue from oil export accounting to almost 85% of the economy. Tourism manufacturing and construction or other industries helping UAE to diversify its economy.
                                                <br />
                                                <a href="https://www.investopedia.com/articles/investing/042915/how-uk-makes-money.asp" target="_blank">Source</a>
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Careers</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Some of the top careers in UAE are:
                                                <br />
                                                1. Accountant
                                                <br />
                                                2. Electrical Engineer
                                                <br />
                                                3. Civil Engineer
                                                <br />
                                                4. Data Scientist
                                                <br />
                                                5. Management Consultant
                                                <br />
                                            </p>
                                        </li>
                                        <li className="country-usa-overview mb-2">
                                            <span>
                                                <img className="mr-2 country-page-tick-img" src={check} alt="" />
                                            </span>
                                            <h4 className="mb-5" style={{ display: "inline" }}>Salary</h4>
                                            <p className="country-usa-overview-mini mt-3">
                                                Median salary of a fresh graduate in UAE generally ranges from AED 10,000 - 20,000
                                            </p>
                                        </li>
                                    </ul>

                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                <section style={{ backgroundColor: "#fff" }} className="py-md-1">
                    <div className="container country-page-features-main-container">
                        <div className="row country-page-feature-container-last justify-content-center">
                            <div className="col-md-6">
                                <ScrollAnimation
                                    animateIn='fadeInLeft'
                                    style={{ 'animation-duration': '1s' }}
                                >
                                    <h3 className="mb-2 mb-md-4 text-center pt-4 pt-md-0"> Credit Issuing Partner </h3>
                                    <img
                                        src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Unismarter-by-Navitas.png" alt=""
                                        class="img-fluid mb-3 d-flex mx-auto shadow p-1"
                                        style={{ borderRadius: "15px", width: "250px" }}
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                                <ScrollAnimation
                                    animateIn='fadeInRight'
                                    style={{ 'animation-duration': '1s' }}
                                >

                                    <h3>The WorldGrad Path To A Degree In The UAE</h3>

                                    <p className="country-usa-overview">Fast track your overseas education from one of the best universities in UAE with the help of the Unismarter program</p>

                                    <ul>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>With The WorldGrad’s Unismarter you can complete the first semester of your course from home</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>From semester 2, you can move to a top ranked university campus and complete your degree</li>
                                        <li className="country-usa-overview mb-3"><span><img id="country-page-tick-para" className="mr-2 country-page-tick-img" src={check} alt="" /></span>Unismarter helps you complete your dream career with savings of up to AED 30,000 - 50,000</li>
                                    </ul>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <a
                                                class="btn-default visa-visit-btn mx-auto"
                                                href="/unismarter"
                                                onClick={() => {
                                                    ReactGA.event({
                                                        category: "Countries",
                                                        action: "Clicks",
                                                        label: "Visit Visa Website - Our Visa Guidance for Australia"
                                                    })
                                                }}
                                            >
                                                Know More
                                            </a>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <div class="universitie-partner-sec" style={{ backgroundColor: "#f8f8f8" }}> */}
                    <div class="container" style={{ backgroundColor: "#f8f8f8" }}>
                        <div class="row">
                            <div class="col-12">
                                {/* <div class="title"> */}
                                    <h2 className="text-center mb-0 mt-md-4">Featured Universities in UAE</h2>
                                {/* </div> */}
                                <Tabs>
                                    <TabPanel>
                                        <section id="rauchbier" class="tab-panel">
                                            <div class="interest-explore-inner">
                                                <div class="swiper-container universities-swiper">
                                                    <div class="swiper-wrapper row justify-content-center m-0">
                                                        {
                                                            uniArr.map(university => {
                                                                return (
                                                                    <div className="col-md-4" key={university.id}>
                                                                        <Link to={`/university-detail/${university.slug}`}>
                                                                            <div class="swiper-slide" value="Open" onClick={() => {
                                                                                ReactGA.event({
                                                                                    category: "Institutions",
                                                                                    action: "Clicks",
                                                                                    label: `UAE - ${university.title}`
                                                                                })
                                                                            }}>
                                                                                <InstituteTabs
                                                                                    ImageUrl={university.acf.university_thumbnail.source_url}
                                                                                    UniversityName={university.title}
                                                                                />
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                {/* </div> */}

            </Layout>
        </div>    
    )
  }
}
export default Countries;

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "UAE"}}}) {
        nodes {
            id
            slug
            title
            acf {
                university_thumbnail {
                    source_url
                }
            }
        }
        }
    }
`
